module.exports = __webpack_public_path__ + "img/Machine-game.9d2d1956.jpg";